import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import DisabledIcon from '@mui/icons-material/LockOutlined';
import EnableIcon from '@mui/icons-material/LockOpenOutlined';
import { grey } from '@mui/material/colors';
import { useIntl } from 'react-intl';
import { useTurnEnable } from '~/hooks/api/useTurnEnable';
import { useQueryClient } from '@tanstack/react-query';
import messages from './messages';
import styles from './styles.module.css';

type TurnDisabledViewProps = {
  turnId: number;
  shiftId: number;
};

export const TurnDisabledView = (props: TurnDisabledViewProps) => {
  const queryClient = useQueryClient();
  const mutation = useTurnEnable({
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['shifts', props.shiftId] });
    },
  });
  const intl = useIntl();
  return (
    <div className={styles['disabled-wrapper']}>
      <div className={styles['disabled-background']}>
        <DisabledIcon
          style={{
            width: '50vh',
            height: '50vh',
            color: grey[200],
          }}
        />
      </div>
      {mutation.isPending ? (
        <div className={styles['enabling-overlay']}>
          <h1>{intl.formatMessage(messages.enabling)}</h1>
          <LinearProgress
            variant="indeterminate"
            style={{
              margin: '14px 0',
            }}
          />
        </div>
      ) : (
        <div className={styles['disabled-overlay']}>
          <h1>{intl.formatMessage(messages.isDisabled)}</h1>
          <Button
            onClick={() => {
              mutation.mutate({
                enable: 'true',
                turnId: props.turnId,
              });
            }}
            color="secondary"
            variant="contained"
            startIcon={<EnableIcon />}
          >
            {intl.formatMessage(messages.enableButton)}
          </Button>
        </div>
      )}
    </div>
  );
};
